import {IRestApiService} from "../types";

export interface IUserInvoiceApiCall {
  downloadInvoice(invoiceId: string): Promise<Blob>;
  getInvoices(page: number, size: number): Promise<any>;
  createInvoice(): Promise<{ url: string; invoice: any }>;
  chargeInvoice(): Promise<{ invoiceId: string; status: string }>;
}

class UserInvoiceApiCall implements IUserInvoiceApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  downloadInvoice = (invoiceId: string): Promise<Blob> => {
    return this.restApiService.get(`user-invoice/download/${invoiceId}`, {
      responseType: 'blob'
    });
  }

  payInvoice = (invoiceId: string): Promise<{ url: string; invoice: any; isNew: boolean }> => {
    return this.restApiService.post(`user-invoice/pay/${invoiceId}`);
  }


  getInvoices = (page: number = 1, size: number = 6): Promise<any> => {
    return this.restApiService.get(`user-invoice/invoices?page=${page}&size=${size}`);
  }

  createInvoice = (): Promise<{ url: string; invoice: any }> => {
    return this.restApiService.post('user-invoice/create-invoice');
  }

  chargeInvoice = (): Promise<{ invoiceId: string; status: string }> => {
    return this.restApiService.post('user-invoice/charge');
  }
}

export default UserInvoiceApiCall;
